import { render, staticRenderFns } from "./Inicis.vue?vue&type=template&id=c5ec4c10&scoped=true&"
import script from "./Inicis.vue?vue&type=script&lang=js&"
export * from "./Inicis.vue?vue&type=script&lang=js&"
import style0 from "./Inicis.vue?vue&type=style&index=0&id=c5ec4c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ec4c10",
  null
  
)

export default component.exports